import React from "react";
import styled from "styled-components";
import {
	colours,
	device,
	getColours,
	isEmptyContentfulEntry,
	richTextHelper,
} from "@helpers";
import type { IModuleContentOverBackgroundImageFields } from "@types-contentful";
import CTAButton from "./CTAButton";

const StyleBackgroundImageContainer = styled.div<{ imageUrl: string }>`
  width: 100%;
  min-height: 370px;
  background-image: url(${(props) => props.imageUrl});
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  
  @media (min-width: ${device.tablet}) {
    min-height: 500px;
  }

  @media (min-width: ${device.desktopS}) {
    min-height: 600px;
  }
`;

const StyleOverlay = styled.div<{
	backgroundColor:
		| "Mint Green"
		| "White"
		| "Pale Peach"
		| "Peach"
		| "Watermelon"
		| "Green";
}>`
  background-color: ${({ backgroundColor }) => getColours(backgroundColor)};
  border-radius: 10px;
  box-shadow: 0 4px 15px 0 rgba(18, 18, 82, 0.2);
  padding: 33px;
  width: calc(100% - 40px);
  max-width: 500px;
margin: 0 16px;
  @media (min-width: ${device.tablet}) {
    padding: 43px;
    width: calc(100% - 128px);
    max-width: 600px;
  }

  @media (min-width: ${device.laptop}) {
    padding: 49px;
    max-width: 700px;
  }

  @media (min-width: ${device.desktopS}) {
    padding: 73px;
    max-width: 800px;
  }

  @media (min-width: ${device.desktop}) {
    padding: 83px;
    max-width: 1000px;
  }
`;

const StyleExtendedButton = styled.span`
  & > * {
    margin: 49px 0 0;
    padding: 10px 28px;
    background-color: ${colours.MIDNIGHT_BLUE};
    @media (min-width: ${device.desktopS}) {
      margin: 73px 0 0;
      padding: 10px 38px;
    }
  }
`;

const ContentfulModuleContentOverBackgroundImage = ({
	headline,
	bodyText,
	buttonText,
	buttonUrl,
	backgroundImage,
	theme,
	name,
}: IModuleContentOverBackgroundImageFields) => {
	return (
		<StyleBackgroundImageContainer
			imageUrl={backgroundImage?.fields?.file?.url || ""}
		>
			<StyleOverlay backgroundColor={theme}>
				<h2>{headline}</h2>
				{!isEmptyContentfulEntry(bodyText) && richTextHelper(bodyText)}
				{!isEmptyContentfulEntry(buttonText) && (
					<StyleExtendedButton>
						<CTAButton
							url={buttonUrl}
							gtmCtaPosition={name}
							gtmCtaText={buttonText}
							ctaButtonColour="Midnight Blue"
						>
							{buttonText}
						</CTAButton>
					</StyleExtendedButton>
				)}
			</StyleOverlay>
		</StyleBackgroundImageContainer>
	);
};

export default ContentfulModuleContentOverBackgroundImage;
